import React from "react";
import styled from "styled-components";

import p from "../img2/img2.jpeg";
import pp from "../img2/img4.jpeg";
import n2 from "../img2/img6.jpeg";
import n3 from "../img2/img5.jpeg";
import n4 from "../img2/img7.jpeg";
import n5 from "../img2/img8.jpeg";
import n6 from "../img2/img9.jpeg";

const MainWrapper = styled.section`
  direction: rtl;
  position: relative;
  overflow: hidden;
  padding: 115px 25px 125px;
  background:
    radial-gradient(ellipse at 50% 0%, rgba(59,130,246,.16), transparent 42%),
    radial-gradient(ellipse at 100% 65%, rgba(124,58,237,.10), transparent 35%),
    #070d19;

  &::before {
    content: "";
    position: absolute;
    width: 500px;
    height: 500px;
    top: 20%;
    left: -300px;
    border-radius: 50%;
    background: rgba(37,99,235,.08);
    filter: blur(100px);
    pointer-events: none;
  }

  @media(max-width:768px) {
    padding: 80px 17px 85px;
  }
`;

const Inner = styled.div`
  position: relative;
  z-index: 1;
  max-width: 1440px;
  margin: auto;
`;

const HeaderArea = styled.div`
  max-width: 850px;
  margin: 0 auto 75px;
  text-align: center;

  @media(max-width:768px) {
    margin-bottom: 45px;
  }
`;

const SmallLabel = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 9px 17px;
  margin-bottom: 25px;
  border: 1px solid rgba(96,165,250,.24);
  border-radius: 50px;
  background: rgba(37,99,235,.09);
  color: #93c5fd;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: .4px;

  span {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: #60a5fa;
    box-shadow: 0 0 12px #60a5fa;
  }
`;

const Title = styled.h1`
  color: #fff;
  font-size: clamp(42px, 5.5vw, 70px);
  font-weight: 900;
  letter-spacing: -2.5px;
  line-height: 1.15;
  margin: 0 0 23px;

  span {
    background: linear-gradient(100deg, #60a5fa 5%, #818cf8 55%, #c084fc 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  @media(max-width:600px) {
    font-size: 43px;
    letter-spacing: -1.5px;
  }
`;

const Subtitle = styled.p`
  max-width: 690px;
  margin: 0 auto;
  color: #9caec5;
  font-size: 17px;
  line-height: 2;
  font-weight: 400;

  @media(max-width:600px) {
    font-size: 15px;
    line-height: 1.85;
  }
`;

const HeaderLine = styled.div`
  width: 65px;
  height: 3px;
  margin: 30px auto 0;
  border-radius: 10px;
  background: linear-gradient(90deg, #3b82f6, #a78bfa);
`;

const ProjectsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 25px;

  @media(max-width:1050px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 20px;
  }

  @media(max-width:650px) {
    grid-template-columns: 1fr;
    gap: 23px;
    max-width: 470px;
    margin: auto;
  }
`;

const Card = styled.article`
  position: relative;
  min-width: 0;
  overflow: hidden;
  border-radius: 21px;
  background: #101a2a;
  border: 1px solid rgba(148,163,184,.13);
  box-shadow: 0 15px 45px rgba(0,0,0,.19);
  transition: transform .4s ease, border-color .4s ease, box-shadow .4s ease;

  &:hover {
    transform: translateY(-7px);
    border-color: rgba(96,165,250,.48);
    box-shadow: 0 25px 55px rgba(0,0,0,.35);
  }

  &:hover .project-image {
    transform: scale(1.06);
  }

  &:hover .visit-arrow {
    transform: translateX(-5px);
  }

  @media(prefers-reduced-motion:reduce) {
    transition: none;

    &:hover {
      transform: none;
    }

    &:hover .project-image {
      transform: none;
    }
  }
`;

const ImageWrapper = styled.div`
  position: relative;
  height: 250px;
  overflow: hidden;
  background: #162338;

  @media(max-width:650px) {
    height: 245px;
  }
`;

const ProjectImage = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform .8s cubic-bezier(.2,.7,.2,1);
`;

const ImageOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to bottom,
    rgba(5,11,22,.02) 40%,
    rgba(5,11,22,.55) 100%
  );
  pointer-events: none;
`;

const Number = styled.div`
  position: absolute;
  top: 16px;
  right: 16px;
  width: 43px;
  height: 43px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 13px;
  color: #fff;
  background: rgba(7,15,29,.76);
  border: 1px solid rgba(255,255,255,.19);
  backdrop-filter: blur(12px);
  font-size: 13px;
  font-weight: 900;
`;

const Category = styled.div`
  position: absolute;
  bottom: 16px;
  right: 16px;
  padding: 8px 14px;
  border-radius: 8px;
  color: #fff;
  background: rgba(37,99,235,.88);
  backdrop-filter: blur(10px);
  font-size: 12px;
  font-weight: 800;
`;

const Content = styled.div`
  padding: 24px 24px 22px;
  display: flex;
  flex-direction: column;
  min-height: 205px;

  @media(max-width:650px) {
    padding: 22px 20px;
  }
`;

const ProjectTitle = styled.h2`
  color: #f8fafc;
  font-size: 20px;
  font-weight: 900;
  line-height: 1.5;
  margin: 0 0 10px;
`;

const Description = styled.p`
  color: #9caec5;
  font-size: 14px;
  line-height: 1.9;
  margin: 0;
  flex: 1;
`;

const CardFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 22px;
  padding-top: 17px;
  border-top: 1px solid rgba(255,255,255,.09);
`;

const ViewText = styled.span`
  color: #71839c;
  font-size: 12px;
  font-weight: 700;
`;

const VisitButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 11px;
  padding: 11px 17px;
  border-radius: 10px;
  color: #fff;
  background: linear-gradient(120deg, #2563eb, #4f46e5);
  text-decoration: none;
  font-size: 13px;
  font-weight: 800;
  box-shadow: 0 6px 18px rgba(37,99,235,.2);
  transition: background .3s ease, box-shadow .3s ease, transform .3s ease;

  &:hover {
    color: #fff;
    text-decoration: none;
    background: linear-gradient(120deg, #3b82f6, #6366f1);
    box-shadow: 0 9px 25px rgba(37,99,235,.35);
    transform: translateY(-2px);
  }

  &:focus-visible {
    outline: 3px solid #93c5fd;
    outline-offset: 4px;
  }
`;

const Arrow = styled.span`
  display: inline-block;
  font-size: 17px;
  transition: transform .3s ease;
`;

const BottomNote = styled.div`
  margin: 65px auto 0;
  max-width: 800px;
  text-align: center;
  padding: 25px 20px;
  border: 1px solid rgba(148,163,184,.13);
  border-radius: 17px;
  background: rgba(255,255,255,.025);

  p {
    color: #aabbd0;
    font-size: 15px;
    line-height: 1.9;
    margin: 0;
  }

  strong {
    color: #fff;
  }

  @media(max-width:650px) {
    margin-top: 40px;
    padding: 22px 17px;

    p {
      font-size: 14px;
    }
  }
`;

export default function UpdatedSlider() {
  const projects = [
    {
      id: 1,
      title: "S.G One ניקיון ואחזקות",
      url: "https://sg1.co.il/",
      img: pp,
      category: "ניהול ואחזקה",
      desc: "עובדי ניקיון, אחזקת מבנים וניהול צוותי ניקיון."
    },
    {
      id: 2,
      title: "נצר הובלות ומנופים",
      url: "https://netzertovala.co.il/",
      img: n5,
      category: "הובלות ומנופים",
      desc: "פתרונות מקצועיים להובלה, הרמה ושינוע לכל סוגי הפרויקטים."
    },
    {
      id: 3,
      title: "אוחנה MMA",
      url: "https://teamohanamma.co.il/",
      img: n2,
      category: "ספורט ואומנויות לחימה",
      desc: "אומנויות לחימה, כושר ובניית ביטחון עצמי."
    },
    {
      id: 4,
      title: "איטומים בגבהים",
      url: "https://www.itumimb.co.il/",
      img: n3,
      category: " איטומים",
      desc: "שיקום מבנים, איטום גגות ועבודות סנפלינג מקצועיות."
    },
    {
      id: 5,
      title: "ג׳ורדן אדרי הפקות",
      url: "https://www.jordanedri.co.il/",
      img: n4,
      category: "הפקות ואירועים",
      desc: "DJ ג׳ורדן אדרי – מוזיקה והפקות לחתונות, בר מצוות ואירועי חברה."
    },
    {
      id: 6,
      title: "רישוי עסקים ישראל",
      url: "https://rishuy-asakim.co.il/",
      img: p,
      category: "ייעוץ ורישוי",
      desc: "ליווי מקצועי להוצאת רישיון עסק מול כל הרשויות."
    },
    {
      id: 7,
      title: "ש.מ הובלות ומנופים",
      url: "https://smtovala.co.il/",
      img: n6,
      category: "הובלות ומנופים",
      desc: "שירותי הובלה, מנופים, הרמות ושינוע בכל הארץ."
    }
  ];

  return (
    <MainWrapper>
      <Inner>
        <HeaderArea>
 

          <Title>
            אתרים שבנויים <span>להצליח !</span>
          </Title>

          <Subtitle>
            כל עסק והסיפור שלו. אנחנו הופכים רעיונות לאתרי אינטרנט
            מקצועיים, עם עיצוב מוקפד, חוויית משתמש מתקדמת
            והתאמה מלאה למחשבים ולמכשירים ניידים.
          </Subtitle>

          <HeaderLine />
        </HeaderArea>

        <ProjectsGrid>
          {projects.map((project) => (
            <Card key={project.id}>
              <ImageWrapper>
                <ProjectImage
                  className="project-image"
                  src={project.img}
                  alt={`תצוגת האתר ${project.title}`}
                  loading="lazy"
                  decoding="async"
                />

                <ImageOverlay />

      

                <Category>
                  {project.category}
                </Category>
              </ImageWrapper>

              <Content>
                <ProjectTitle>
                  {project.title}
                </ProjectTitle>

                <Description>
                  {project.desc}
                </Description>

                <CardFooter>

                  <VisitButton
                    href={project.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`צפה באתר ${project.title}`}
                  >
                    לצפייה באתר
                    <Arrow className="visit-arrow">←</Arrow>
                  </VisitButton>
                </CardFooter>
              </Content>
            </Card>
          ))}
        </ProjectsGrid>

        <BottomNote>
          <p>
            <strong>גם העסק שלך יכול להיראות ככה.</strong>
            {" "}אנחנו בונים אתרים בהתאמה אישית, עם חשיבה על העיצוב,
            חוויית המשתמש והנוכחות שלך בגוגל.
          </p>
        </BottomNote>
      </Inner>
    </MainWrapper>
  );
}